import SelectAllCheckbox from './selectAllCheckbox.container';

export default SelectAllCheckbox